import React from "react";
import { getLibelleByIdInIIdLibelle, isNumeric, TypeCompteSociete } from "../../config/helpers";

interface IProps {
  Item?: string;
}

const HtmlRenderTypeCompteSociete: React.FC<IProps> = ({ Item }) => {
  return (
    <span >
      {" "}
      {Item && isNumeric(Item) && getLibelleByIdInIIdLibelle(Number(Item),TypeCompteSociete)}
    </span>
  );
};

export default HtmlRenderTypeCompteSociete;
